import React from "react"
import {Deal} from "@irati/types"
import authentication from "@irati/auth"
import DealFavourites from "./DealFavourites"

interface Data {
  isFavourite: boolean
  deal?: Deal
}

interface Props {
  dealId: string
  children: (data: Data) => any
}

const IsDealFavourited: React.FC<Props> = (props) => {
  return (
    <DealFavourites variables={{userId: authentication.user().uuid}}>
      {(apollo) => {
        const deals = apollo.data?.dealFavourites || []
        const deal = deals.filter((t) => t.uuid === props.dealId)[0]
        const isFavourite = !!deal

        return props.children({isFavourite, deal})
      }}
    </DealFavourites>
  )
}

export default IsDealFavourited
